module.exports = __webpack_public_path__ + "static/media/PoppinsBold.9e379fd8.ttf";